<i18n>
{
  "en": {
    "recommended_categories": "Popular Categories",
    "category_list": "All Categories"
  },
  "ja": {
    "recommended_categories": "人気カテゴリー",
    "category_list": "カテゴリー一覧"
  }
}
</i18n>

<template>
<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<div class="container">
  <div class="section">
    <h2>{{ $t('recommended_categories') }}</h2>
    <div class="button-box">
        <router-link
          v-for="(category, index) in categoryList"
          v-if="categoryMap[category]"
          :key="index"
          :to="`/search/?c=${categoryMap[category].category_id}`"
          class="button is-outlined is-rounded">
            {{ categoryMap[category].name[locale] }}
        </router-link>
    </div>
    <div class="section">
      <div class="button-box is-centered">
        <router-link class="button is-outlined is-large is-rounded" to="/category/">{{ $t('category_list') }}<i class="iconf-keyboard-arrow-right is-right"></i></router-link>
      </div>
    </div>
  </div>
</div>
</template>

<script>
/* eslint max-len: 0 */

import BifrostAPI from '@/assets/js/services/Bifrost/API';

export default {
  props: {
    categories: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      categoryList: [],
      categoryMap: {},
    };
  },
  mounted() {
    const bfAPI = new BifrostAPI();
    bfAPI.getCategories().then((categories) => {
      this.categoryList = this.categories.split(',');

      Object.keys(categories).forEach((categoryId) => {
        if (this.categoryList.includes(categories[categoryId].name.ja)) {
          this.$set(this.categoryMap, categories[categoryId].name.ja, categories[categoryId]);
        }
      });
    });
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
